export default {
  hi_im_neela: 'Hi, ich bin Neela,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  arabic: 'عربي',
  polish: 'Polska',
  italian: 'Italiano',
  aareons_virtual: 'die virtuelle Assistentin von Aareon.',
  media: 'Media',
  media_link: 'https://neela.aareon.de/media',
  contact: 'Kontakt',
  contact_link: 'https://neela.aareon.de/contact',
  privacy: 'Datenschutz',
  privacy_link: 'https://www.aareon.de/sixcms/detail.php/46076',
  terms_of_use: 'Nutzungsbedingungen',
  terms_of_use_link:
    'https://www.aareon.com/Allgemeine_Informationen/Nutzungsbedingungen.2366.html',
  legal_notice: 'Impressum',
  legal_notice_link: 'https://neela.aareon.de/legal',
  show_system_messages: 'Systemnachrichten anzeigen',
  dont_show_system_messages: 'Systemnachrichten ausblenden',
  logged_in: 'Mieter ist authentifiziert',
  logged_out: 'Anonymer Nutzer',
  button_switch_locale: 'Sprache ändern',
  button_tooltip_activate_voice_recognition: 'Spracherkennung aktivieren',
  date_input: 'Datum auswählen',
  date_range: 'Zeitspanne',
  from: 'von',
  to: 'bis',
  choose_two_dates: 'Bitte wählen Sie zwei Daten',
  avatar: 'Avatar',
  exit: 'Ende',
  new: 'Neu',
  back: 'Zurück',
  suggestions: 'Vorschläge',
  senton: 'Gesendet am',
  message_placeholder: 'Nachricht hier eingeben',
  comment_placeholder: 'Kommentar hier eingeben',
  file_max_upload_text: 'Es können maximal 20 Dateien hochgeladen werden',
  message_button_label: 'Senden',
  please_confirm: 'Bitte bestätigen',
  no: 'Nein',
  yes: 'Ja',
  modal_delete_session: 'Sitzung löschen',
  modal_delete_session_notification:
    'Wenn Sie das Fenster schließen, wird Ihre Sitzung ebenfalls gelöscht.<br>Sind Sie damit einverstanden?',
  template_contact_time: 'Wann dürfen wir Sie kontaktieren?',
  template_pause:
    'Ihre Sitzung wurde pausiert. In Kürze wird sich einer unserer Support Mitarbeiter um Ihr Anliegen kümmern.',
  template_continue_after_pause:
    'Ihre Sitzung wurde fortgesetzt. Sie können nun weiter mit unserem Chatbot schreiben.',
  button_apply: 'Übernehmen',
  button_cancel: 'Abbrechen',
  none: 'Keine',
  book_appointment: 'Termin buchen',
  address_input: 'Adresseingabe',
  data_processing: 'Datenverarbeitung',
  privacy_policy: 'Datenschutzerklärung',
  data_processing_notification_before_link:
    'Damit Sie diesen Chat-Service in Anspruch nehmen können, ist es notwendig, dass Sie die ',
  data_processing_notification_after_link: 'akzeptieren.',
  button_accept: 'Akzeptieren',
  select_date: 'Datum auswählen',
  rate_conversation: 'Wie würden Sie dieses Gespräch bewerten?',
  new_ticket_question: 'Kann ich sonst noch etwas für Sie tun?',
  thank_you:
    'Danke für Ihre Unterstützung. Ihr Feedback hilft mir, um mich stets zu verbessern.',
  goodbye: 'Bis bald',
  start_new: 'Neues Gespräch beginnen',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_DE_BG,
  expand_quickreplies: 'Mehr',
  collapse_quickreplies: 'Weniger',
  login: 'Anmelden',
  logout: 'Abmelden',
  close: 'Schließen',
  upload_file: 'Datei zum Hochladen hier ablegen',
  upload_file_or: 'oder',
  Upload_file_select: 'Dateien hinzufügen',
  upload_file_text: 'Datei ablegen um sie hochzuladen',
  show_attachments: 'Anhang anzeigen',
  hide_attachments: 'Anhang ausblenden',
  maximize: 'Maximieren',
  minimize: 'Minimieren',
  feedback_helpful: 'Diese Antwort hat mir geholfen',
  feedback_not_helpful: 'Diese Antwort hat mir nicht geholfen',
  chatProtocol: 'ChatProtokoll',
  showMore: 'Mehr anzeigen',
  showLess: 'Weniger anzeigen',
  uploadTooltip: 'Datei hochladen',
  uploadFilesTooltip: 'Dateien hochladen',
  pdfDownloadTooltip: 'Konversation herunterladen',
  feedbackDescription: 'Anregungen an uns',
  feedbackPlaceholder: 'Nachricht hier eingeben...',
  feedbackSubtitle: {
    description:
      'Hier können Sie uns allgemeine Anregungen, Vorschläge und Wünsche mitteilen.',
    note: 'Bitte beachten Sie, dass wir darauf nicht antworten können.',
    hint:
      'Alle anderen Anliegen, die ganz konkret Ihr Mietverhältnis oder die Suche nach einer Wohnung betreffen, können Sie uns im Chat schildern.'
  },
  sendFeedback: 'Senden',
  giveFeedback: 'Anregungen an uns',
  feedbackSubmittedSuccessfully: 'Ihr Anregung wurde erfolgreich übermittelt',
  thanks: 'Danke'
}
